var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMulticolourCircleTick = function SvgMulticolourCircleTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#d6cdd4",
    strokeWidth: 9,
    d: "M10.689 46.314c-3.51-4.397-5.625-10.078-5.625-16.28 0-5.604 1.726-10.78 4.647-14.97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#efebee",
    strokeWidth: 9,
    d: "M29.555 5.254a24.88 24.88 0 0 0-20 10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff2e5b",
    strokeWidth: 9,
    d: "M29.555 5.254c13.807 0 25 11.256 25 25.141 0 6.13-2.181 11.747-5.805 16.11"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#84687d",
    strokeWidth: 9,
    d: "M49.184 45.943c-4.638 5.348-11.613 8.75-19.414 8.75-7.757 0-14.697-3.364-19.336-8.66"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#37CF8E",
    fillRule: "evenodd",
    d: "M43.509 22.63 25.073 41.066l-9.23-9.23 4.65-4.65 4.58 4.58L38.86 17.981z",
    clipRule: "evenodd"
  })));
};
export { SvgMulticolourCircleTick as ReactComponent };
export default __webpack_public_path__ + "images/multicolour-circle-tick.svg";